export default "__VITE_ASSET__DmCNmi5N__"